import { useState } from 'react'

import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'

import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { DashboardPanel } from '../components/DashboardPanel'
import { EngineerRail } from '../components/EngineerRail'
import { ExceptionBoard } from '../components/ExceptionBoard'
import { ExceptionDrawer } from '../components/ExceptionDrawer'
import { Filters } from '../components/Filters'
import type { ExceptionsFilter } from '../hooks/useApi'

export default function ControlTower() {
  const [filter, setFilter] = useState<ExceptionsFilter>({})
  const [selectedId, setSelectedId] = useState<string | null>(null)
  const [engineerRailOpen, setEngineerRailOpen] = useState(false)

  return (
    <>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Stack spacing={2}>
          <DashboardPanel
            filter={filter}
            onFilterChange={setFilter}
            onSelectException={setSelectedId}
          />

          <Paper variant="outlined" sx={{ p: { xs: 2, md: 2.5 } }}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mb: 2, alignItems: { sm: 'center' } }}>
              <Stack sx={{ flexGrow: 1 }}>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  Exception list
                </Typography>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {filter.severity || filter.code || filter.subject_type
                    ? 'Filtered · adjust the toolbar to widen or clear.'
                    : 'All open exceptions across the tenant, ranked by severity + age.'}
                </Typography>
              </Stack>
              <Button
                size="small"
                variant="outlined"
                startIcon={<GroupsOutlinedIcon />}
                onClick={() => setEngineerRailOpen(true)}
                sx={{ textTransform: 'none', alignSelf: { xs: 'flex-start', sm: 'auto' } }}
              >
                Fleet
              </Button>
            </Stack>

            <Filters filter={filter} onChange={setFilter} />

            <Divider sx={{ my: 2 }} />

            <ExceptionBoard filter={filter} selectedId={selectedId} onSelect={setSelectedId} />
          </Paper>
        </Stack>
      </Container>

      <Drawer
        anchor="right"
        open={engineerRailOpen}
        onClose={() => setEngineerRailOpen(false)}
        slotProps={{ paper: { sx: { width: { xs: '100%', sm: 360 }, p: 2 } } }}
      >
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1.5 }}>
          Engineer fleet
        </Typography>
        <EngineerRail />
      </Drawer>

      <ExceptionDrawer id={selectedId} onClose={() => setSelectedId(null)} />
    </>
  )
}
